import { formatDate } from './formatting';
import ReportSaveWindow from '../../content/report_save_window';
import { extractColumnKey } from './composite_keys';
import { deriveColumnSets, findColumnSetItems } from './report_preferences';

export const saveReportScreen = ({
  payload,
  snapshots,
  user,
  reportsList,
  aggregatedItems,
  columnSets,
  reportPreferences,
  visibleColumns,
  reportType,
  onSubmitSave,
  onCancelSave,
  columnsJson,
}) => {
  const params = {};

  params.report = payload.report;
  params.rollup = payload.rollup;
  params.region = payload.region;
  params.marketplace = payload.marketplace;
  params.channel = payload.channel;
  params.timeFrame = payload.timeFrame;
  params.productLines = payload.productLines;
  params.component = payload.component;
  params.currency = payload.currency;

  params.snapshots = snapshots;
  params.user = user;

  params.aggregatedMarketplaces = aggregatedItems.marketplaces;
  params.aggregatedTimeFrames = aggregatedItems.timeFrames;

  const columnSetConfig = resolveColumnSetsAndOverrides(
    columnSets,
    reportPreferences,
    reportType,
    visibleColumns,
    columnsJson
  );
  
  params.columnSets = columnSetConfig.columnSets;
  params.columnSetOverrides = columnSetConfig.columnSetOverrides;

  return (
    <ReportSaveWindow
      onCancel={onCancelSave}
      onSubmit={onSubmitSave}
      reportsList={reportsList}
      params={params}
      formatDate={formatDate}
      user={user}
    />
  );
};

export const resolveColumnSetsAndOverrides = (
  columnSets,
  reportPreferences,
  reportType,
  visibleColumns,
  columnsJson
) => {
  const { columnSetOverrides } = columnSets || {};
  const selectedColSets = resolveColumnSets(columnSets, reportPreferences, reportType);

  return {
    columnSets: selectedColSets.map((s) => (s.id ? s.id : s)).join(','),
    columnSetOverrides: resolveColumnSetOverrides(
      columnSetOverrides,
      selectedColSets,
      visibleColumns,
      columnsJson,
      reportType
    ).join(','),
  };
};

export const resolveColumnSets = (columnSets, reportPreferences, reportType) => {
  const { selectedColumnSetsByUser, selectedColumnSets } = columnSets || {};

  if (selectedColumnSetsByUser) {
    return selectedColumnSetsByUser;
  }

  if (selectedColumnSets && selectedColumnSets.length) {
    return selectedColumnSets;
  }

  return deriveColumnSets(columnSets, reportPreferences, reportType);
};

const resolveColumnSetOverrides = (columnSetOverrides, selectedColumnSets, visibleColumns, columnsJson, reportType) => {
  if (columnSetOverrides && Object.keys(columnSetOverrides).length) {
    return Object.keys(columnSetOverrides);
  }

  const columnSetItems = findColumnSetItems(columnsJson, selectedColumnSets, reportType);

  const columns = [...new Set((columnSetItems || []).map((s) => s.columns).flat())];

  const visibleColumnKeys = visibleColumns.map((c) => extractColumnKey(c));

  const combined = [...new Set(visibleColumnKeys.concat(columns))];
  return combined.filter(
    (c) =>
      (visibleColumnKeys.includes(c) && !columns.includes(c)) || (!visibleColumnKeys.includes(c) && columns.includes(c))
  );
};

const defaultColumnSet = (reportPreferences, reportType) => {
  const { defaultPreferences } = reportPreferences || {};
  const defaultPrefForReportType = defaultPreferences.find((p) => p.reportType === reportType);
  const { columnSets, columns } = defaultPrefForReportType || {};

  return {
    columnSets: columnSets.map((s) => {
      return { id: s, columns };
    }),
  };
};



// WEBPACK FOOTER //
// ./src/components/reports/utils/save_report.js